export default class MedocReference {
    public id: number;
	public code: string;
    public name: string;
	public description?: string;
    public packaging?: string;
    public shape?: string;

    constructor(id: number, name: string, code: string) {
		this.id = id;
        this.code = code;
        this.name = name;
	}
}